import apiClient from "./base";

const api = {


    auth : {

        login : async ({email, password})=>{

            try{

                const { data } = await apiClient.post('/admin/login', {email, password})

                return data;

            }catch(e){
                throw e
            }

        },

        auto_login : async ()=>{
            
            try{

                const token = localStorage.getItem('token')
                // const { data } = await apiClient.post('/admin/auto_login', {}, {headers : {Authorization : `Bearer ${token}`}})
                const { data } = await apiClient.post('/admin/auto_login')

                return data;

            }catch(e){
                throw e
            }
        }
    },

    category : {

        create : async ({name, description})=>{


            try{

                const { data } = await apiClient.post("/category/create", {name, description})

                return data

            }catch(e){

                throw e
            }
        },

        read : async ()=>{


            try{

                const { data } = await apiClient.get("/category/read")

                return data

            }catch(e){

                throw e
            }
        },

        read_one : async ({id})=>{

            try{
                
                console.log(id)
                const { data } = await apiClient.get("/category/one", {params : { id : id}})

                console.log(data)
                return data

            }catch(e){

                throw e
            }
        },

        delete : async ({id})=>{

            try{

                const { data } = await apiClient.post("/category/delete", {}, {params : { id : id}})

                return data 

            }catch(e){

                throw e
            }
        }
    },

    product : {

        create : async (product)=>{

            try{
                const { data } = await apiClient.post("/product/create", product, {headers : {"Content-Type" : "multipart/form-data"}})

                return data

            }catch(e){

                throw e
            }

        },

        read_all : async ()=>{

            try {
                
                const { data } = await apiClient.get("/product/get/all")

                return data 

            } catch (error) {
                throw error
            }

        },


        read_one : async ({id})=>{

            try {
                
                const { data } = await apiClient.get("/product/admin/get", {params : {id : id}})

                return data 

            } catch (error) {
                throw error
            }

        },

        delete : async ({id})=>{

            try{

                const { data } = await apiClient.post("/product/delete", {}, {params : { id : id}})

                return data 

            }catch(e){

                throw e
            }
        },


        update : async ({id, product})=>{

            try{
                const { data } = await apiClient.post("/product/update", product, {headers : {"Content-Type" : "multipart/form-data"}, params : {id : id}})

                return data

            }catch(e){

                throw e
            }

        },

        stock : {

            create : async (body)=>{

                try{

                    const { data } = await apiClient.post("/product/stock/create", body)

                    return data

                }catch(e){
                    console.log(e)
                    throw e
                }
            },


            readAll : async ({id})=>{

                try{

                    const { data } = await apiClient.get('/product/stock', {params : {id : id}})

                    return data

                }catch(e){

                    throw e
                }
            },

            
        }
    },

    admin : {

        add : async ({body})=>{

            try {

                const { data } = await apiClient.post("/admin/add", body)

                return data 
                
            } catch (error) {
                throw error
            }

        },


        read_all : async ()=>{

            try{   

                const { data } = await apiClient.get("admin/")

                return data;

            }catch(e){

                throw e
            }
        },


        read_one : async ({id})=>{

            try{   

                const { data } = await apiClient.get("admin/detail", {params : {id : id}})

                return data;

            }catch(e){

                throw e
            }
        },

        update : async ({body})=>{

            try {
                
                const { data } = await apiClient.post("/admin/update", body)

                return data
                
            } catch (error) {
                
                throw error
            }

        },

        delete : async ({id})=>{

            try{

                const { data } = await apiClient.post("/admin/delete", {}, {params : { id : id}})

                return data 

            }catch(e){

                throw e
            }
        },
    },

    promo : {
        create : async ({promo})=>{

            try {
                
                const { data } = await apiClient.post("/promo/create", promo);

                return data

            } catch (error) {
                throw error
            }
        },

        read : {

            all : async ()=>{

                try {

                    const { data } = await apiClient.get("/promo")

                    return data
                    
                } catch (error) {
                    throw error
                }

            },

            one : async ({id})=>{

                try {
                    
                    const { data } = await apiClient.get("/promo/one", {params : {id : id}})

                    return data

                } catch (error) {
                    throw error
                }
            }
        },

        delete : async ({id})=>{

            try {
                
                const { data } = await apiClient.post("/promo/delete", {}, {params : {id : id}})

                return data

            } catch (error) {
                throw error
            }
        },

        product : {
            
            
            delete : async ({product_id, promotion_id})=>{

                try {

                    console.log(product_id, promotion_id)
                    const { data } = await apiClient.post("/promo/product/delete", {product_id, promotion_id})
                    
                    return data

                } catch (error) {
                    throw error
                }
            }
        }
    },

    user : {

        read : {

            all : async ()=>{

                try {

                    const { data } = await apiClient.get("/user/get")

                    return data 
                    
                } catch (error) {

                    throw error
                }
            },


            one : async ({id})=>{

                try {

                    const {data} = await apiClient.get("/user", {params : {id : id}})

                    return data 
                    
                } catch (error) {
                    
                    throw error
                }
            }
        }
    },


    order : {

        read : {
            
            all : async ()=>{

                try {

                    const { data } = await apiClient.get("/order")

                    return data 
                    
                } catch (error) {

                    throw error
                }
            },


            one : async ({id})=>{

                try {

                    const { data } = await apiClient.get("/order/details", {params : {id : id}})

                    return data 
                    
                } catch (error) {
                    
                    throw error
                }
            }
        },

        delete : async ({id})=>{

            try {

                const {data} = await apiClient.post("/order/delete", {}, {params : {id : id}})

                return data;
                
            } catch (error) {
                


            }

        },

        getGraphData : async (period)=>{

            try {

                const { data } = await apiClient.get('/order/graph', {params : {period : period}})

                return data
                
            } catch (error) {

                throw error
            }
        }
    },

    delivery : {

        read : {

            all : async ()=>{

                try {

                    const { data } = await apiClient.get("/order/delivery")

                    return data 
                    
                } catch (error) {
                    throw error
                }
            },

            one : async ({id})=>{

                try {

                    const { data } = await apiClient.get("/order/delivery/one", {params : {id : id}})

                    return data 
                    
                } catch (error) {
                    
                    throw error
                }
            }
        },

        update : async (delevery)=>{

            try {

                const { data } = await apiClient.post("/order/delivery/update", delevery)

                return data 
                
            } catch (error) {
                throw error
            }
        }
    }

    
}


export default api;